var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDrawerOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_643_13036)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0887 2.08889L5.08413 2.08889C4.5839 2.08889 4.17463 2.49817 4.17463 2.99839C4.17463 3.49862 4.5839 3.9079 5.08413 3.9079L15.0887 3.9079C15.5889 3.9079 15.9982 3.49862 15.9982 2.99839C15.9982 2.49817 15.5889 2.08889 15.0887 2.08889ZM15.0887 6.63641L7.81264 6.63641C7.31241 6.63641 6.90314 7.04568 6.90314 7.54591C6.90314 8.04614 7.31241 8.45541 7.81264 8.45541H15.0887C15.5889 8.45541 15.9982 8.04614 15.9982 7.54591C15.9982 7.04568 15.5889 6.63641 15.0887 6.63641ZM15.9982 12.0934C15.9982 11.5932 15.5889 11.1839 15.0887 11.1839L5.08413 11.1839C4.5839 11.1839 4.17463 11.5932 4.17463 12.0934C4.17463 12.5937 4.5839 13.0029 5.08413 13.0029L15.0887 13.0029C15.5889 13.0029 15.9982 12.5937 15.9982 12.0934ZM0.263763 4.92654L2.88313 7.54591L0.263763 10.1653C0.179559 10.2495 0.112765 10.3494 0.0671943 10.4595C0.0216237 10.5695 -0.001831 10.6874 -0.001831 10.8065C-0.001831 10.9256 0.0216237 11.0435 0.0671943 11.1535C0.112765 11.2635 0.179559 11.3635 0.263763 11.4477C0.347966 11.5319 0.44793 11.5987 0.557947 11.6442C0.667964 11.6898 0.785881 11.7133 0.904963 11.7133C1.02404 11.7133 1.14196 11.6898 1.25198 11.6442C1.36199 11.5987 1.46196 11.5319 1.54616 11.4477L4.81128 8.18256C4.89559 8.09842 4.96248 7.99848 5.00812 7.88845C5.05376 7.77843 5.07726 7.66048 5.07726 7.54136C5.07726 7.42225 5.05376 7.3043 5.00812 7.19427C4.96248 7.08425 4.89559 6.9843 4.81128 6.90016L1.54616 3.63505C1.19146 3.28034 0.618469 3.28034 0.263763 3.63505C-0.0818484 3.98975 -0.0909434 4.57183 0.263763 4.92654Z",
    fill: "white",
    fillOpacity: 0.87
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_643_13036"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "matrix(-1 0 0 -1 15.9982 16.0029)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrawerOpen);
export default __webpack_public_path__ + "static/media/DrawerOpen.4357d39a9ad36bcaa5b839f4bc43e701.svg";
export { ForwardRef as ReactComponent };